import React from 'react';
import Layout from '../containers/Layout';
import PageTitle from '../components/PageTitle';
import Text from '../components/Text';
import { BASE_SPACING } from '../styles';

const FourOFour = () => (
  <Layout>
    <PageTitle messageId="app.404.title" />
    <Text messageId="app.404.text" style={{ padding: BASE_SPACING }} />
  </Layout>
);

export default FourOFour;
